<template>
  <article
    :aria-labelledby="item.name && item.show_title ? headingId : undefined"
    class="w-full px-0 md:px-8"
  >
    <div class="bg-white border-round flex flex-column gap-3 px-2 md:px-3 py-3 md:py-4">
      <h2
        v-if="item.name && item.show_title"
        :id="headingId"
        :class="[getTextClass(web_content_type), 'sm:text-3xl md:text-4xl my-0']"
      >
        {{ item.name }}
      </h2>

      <div
        class="timetable-content generic-card__body text-sm w-full mx-auto overflow-auto px-3 sm:px-4"
        v-html="item.body"
      />
    </div>
  </article>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  web_content_type: {
    type: Object,
    required: true,
  },
})

const headingId = `timetable-${props.item.id ?? props.item.web_section_id}-heading`
</script>

<style scoped>
.timetable-content {
  color: var(--text-color);
  line-height: 1.6;
}

.timetable-content :deep(a) {
  color: var(--primary-color);
}

.timetable-content :deep(table) {
  width: 100%;
  min-width: 40rem;
  border-collapse: collapse;
}

.timetable-content :deep(th),
.timetable-content :deep(td) {
  padding: 0.75rem;
  border: 1px solid var(--surface-border);
  vertical-align: top;
}

.timetable-content :deep(th) {
  background: var(--surface-100);
  color: var(--text-color);
}
</style>
